// extracted by mini-css-extract-plugin
module.exports = {"Input":"AppFormProfilePicture_Input__11vt1","Main":"AppFormProfilePicture_Main__1Jj9Z","Overlay":"AppFormProfilePicture_Overlay__2SZJd"};